﻿{
  "registration": {
    "sectionTitle": "ŐRPONT",
    "title": "Regisztráció",
    "firstName": "Keresztnév",
    "lastName": "Vezetéknév",
    "company": "Fuvarozó vállalat",
    "companyPlaceholder": "Írjon be 3 betűt a kereséshez...",
    "plate": "Rendszám",
    "orderNumber": "Rendelésszám",
    "photo": "Sofőr fénykép",
    "takePhoto": "Fénykép készítése",
    "chooseFile": "Fájl kiválasztása",
    "security": "Elolvastam és elfogadom a telephely biztonsági protokollját",
    "securitySub": "Egyéni védőeszköz kötelező · Tiltott zónák · Max. sebesség 10 km/h",
    "submit": "Regisztráció érvényesítése",
    "success": "Regisztráció sikeresen befejezve",
    "qrInstruction": "Szkennelje be ezt a QR-kódot, hogy hozzáférjen a telephely térképéhez és szolgáltatásaihoz telefonjáról vagy táblagépéről.",
    "qrDone": "Regisztráció kész",
    "nextRegistration": "Következő regisztráció",
    "errorRequired": "Ez a mező kötelező",
    "errorSecurity": "El kell fogadnia a biztonsági protokollt",
    "phone": "Telefonszám",
    "phonePlaceholder": "+36 20 123 4567",
    "tankCapacity": "Tartálykapacitás (liter)",
    "tankCapacityPlaceholder": "Pl. 26000",
    "baffles": "Válaszfalak",
    "bafflesYes": "Igen",
    "bafflesNo": "Nem",
    "tare": "Jármű tömege (kg)",
    "tarePlaceholder": "Pl. 14500",
    "washCertificate": "Mosási igazolás",
    "washWashed": "Kimosva",
    "washNotWashed": "Nem mosva",
    "adr": "ADR megfelelőség",
    "adrCompliant": "Megfelel",
    "adrNotCompliant": "Nem felel meg",
    "groupContact": "Kapcsolat",
    "groupVehicle": "Jármű és Tartály",
    "groupCompliance": "Megfelelőség",
    "groupSecurity": "Biztonság",
    "securityProtocol": "Telephely biztonsági protokoll",
    "groupMedia": "Média",
    "fieldOptional": "Nem kötelező",
    "fieldRequired": "Kötelező",
    "wizardStepLabel": "Lépés",
    "wizardStep1Title": "Milyen műveletet végez?",
    "wizardStep1Subtitle": "Válassza ki a beavatkozás típusát a telephelyen",
    "wizardExpedition": "Expedíció",
    "wizardLivraison": "Szállítás",
    "wizardStep2Title": "Rendelésszám",
    "wizardOrderLabel": "Rendelésszám",
    "wizardOrderHintExpedition": "Példa: AR… vagy 5…",
    "wizardOrderHintLivraison": "Példa: 85…",
    "wizardOrderError": "Érvénytelen formátum ehhez a művelettípushoz",
    "wizardOrderUnknown": "Nincs / nem ismerem a rendelésszámot",
    "wizardOrderPlanned": "Tervezett rendelés megtalálva — mezők előtöltve",
    "wizardValidate": "Megerősítés",
    "wizardBack": "Vissza",
    "wizardStep3Title": "Milyen típusú járművet vezet?",
    "wizardStep3Subtitle": "Válassza ki a járművét",
    "wizardTank": "Tartálykocsi",
    "wizardTrailer": "Pótkocsi",
    "wizardModalIso": "ISO tartály?",
    "wizardModalContainer": "Konténer?",
    "wizardYes": "IGEN",
    "wizardNo": "NEM",
    "chassisPlate": "ISO szám",
    "containerPlate": "Konténer szám",
    "tareIso": "ISO Tara (kg)",
    "tareContainer": "Konténer tara (kg)",
    "pinTitle": "PIN-kód",
    "pinError": "Helytelen kód",
    "pinCancel": "Mégse",
    "capturePhoto": "Rögzítés",
    "guardAccess": "Őrség hozzáférés",
    "trailerPlate": "Pótkocsi rendszám"
  },
  "driver": {
    "title": "Üdvözöljük a telephelyen",
    "subtitle": "Kövesse az őrpont utasításait",
    "yourPosition": "Az Ön pozíciója",
    "enableGps": "Helymeghatározás aktiválása",
    "gpsActive": "Helymeghatározás aktív",
    "gpsError": "Helymeghatározás nem elérhető",
    "gpsPermission": "Engedélyezze a helymeghatározást",
    "helpBtn": "Segítségre van szükségem",
    "helpSent": "Segítségkérés elküldve",
    "helpAlready": "Kérelmét megkaptuk",
    "sessionExpired": "Munkamenet befejezve",
    "sessionExpiredMsg": "Munkamenete lejárt. Köszönjük látogatását.",
    "waitingMsg": "Kérjük várjon, egy munkatárs hamarosan foglalkozik Önnel",
    "estimatedPassage": "Becsült áthaladási idő",
    "instruction": "Utasítás",
    "instructionClose": "Bezárás"
  },
  "incident": {
    "alertTitle": "RIASZTÁS — AZONNALI EVAKUÁLÁS",
    "alertSubtitle": "Kövesse azonnal a térkép utasításait",
    "alertInstruction": "Menjen a legközelebbi gyülekezési ponthoz",
    "safeNow": "Biztonságban vagyok",
    "normalMode": "A helyzet visszatért a normálishoz",
    "evacuation": "Evakuációs pont",
    "assembly": "Gyülekezési pont",
    "firstAid": "Elsősegély"
  },
  "messages": {
    "title": "Üzenet az operátortól",
    "placeholder": "Írjon üzenetet a sofőrnek...",
    "send": "Küldés",
    "dictate": "Diktálás",
    "translatedTo": "Lefordítva",
    "noMessages": "Nincsenek elküldött üzenetek",
    "reactionSent": "Reakció elküldve"
  }
}
